<div matDialogTitle class="relative flex items-start justify-between">
    <div class="w-full text-center title" [innerHTML]="this._data?.content?.title"></div>
    <button mat-icon-button class="absolute close-button">
        <mat-icon mat-dialog-close="true" [icIcon]="icClose" height="22px" width="22px"></mat-icon>
    </button>
</div>
<mat-dialog-content class="how-its-work">
    <quill-editor [modules]="quillConfig"  [(ngModel)]="quilData" [readOnly]="true"></quill-editor>  
    <!-- <div class="content-dialog" id="howItWork"></div> -->
</mat-dialog-content>